import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import * as IBooks from '../../../../interfaces/merchants/resources/books';
import * as $ from './helper';

import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksSelectedMenu from '../../../../components/books/model1/BooksSelectedMenu';
import BooksSelectedStaff from '../../../../components/books/staffs/BooksSelectedStaff';

interface StaffProps {
  staff: IBooks.Staff;
  onChangeTarget: (targets: {
    course: boolean;
    options: boolean;
    staff?: boolean;
  }) => void;
  args: { course: boolean; options: boolean; staff?: boolean };
  withBorderBottom?: boolean;
  withBorderTop?: boolean;
}

const Staff: React.SFC<StaffProps & InjectedIntlProps> = ({
  staff,
  onChangeTarget,
  args,
  withBorderTop,
  withBorderBottom,
  intl,
}) => (
  <BooksSelectedStaff
    name={
      $.isRandomStaff(staff)
        ? intl.formatMessage({ id: 'books.booksMenu.noSelect' })
        : staff.name
    }
    id={staff.id}
    changeStaff={() => onChangeTarget(args)}
    withBorderTop={withBorderTop}
    withBorderBottom={withBorderBottom}
  />
);

interface Props {
  firstSelected?: IBooks.Switch;
  course: IBooks.Course;
  options: IBooks.Option[];
  staff?: IBooks.Staff;
  onChangeTarget: (targets: {
    course: boolean;
    options: boolean;
    staff?: boolean;
  }) => void;
}

const InputBookingTargetPreview: React.SFC<Props & InjectedIntlProps> = ({
  firstSelected,
  course,
  options,
  staff,
  onChangeTarget,
  intl,
}) => {
  if (!firstSelected) {
    // model4以外（コース/スタッフ選択の必要がない場合）
    return (
      <BooksLabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() => onChangeTarget({ course: true, options: true })}
          changeOption={() => onChangeTarget({ course: false, options: true })}
        />
      </BooksLabeledContainer>
    );
  }
  return firstSelected === IBooks.Switch.Course ? (
    <div>
      <BooksLabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() =>
            onChangeTarget({ course: true, options: true, staff: true })
          }
          changeOption={() =>
            onChangeTarget({ course: false, options: true, staff: true })
          }
        />
        {staff && (
          <Staff
            staff={staff!}
            onChangeTarget={onChangeTarget}
            args={{ course: false, options: false, staff: true }}
            withBorderTop={true}
            intl={intl}
          />
        )}
      </BooksLabeledContainer>
    </div>
  ) : (
    <div>
      <BooksLabeledContainer
        label={intl.formatMessage({
          id: 'books.formsLabel.selectedBooks',
        })}
        contentsPadding={true}
      >
        <Staff
          staff={staff!}
          onChangeTarget={onChangeTarget}
          args={{ course: true, options: true, staff: true }}
          withBorderBottom={true}
          intl={intl}
        />
        <BooksSelectedMenu
          name={course.name}
          options={options}
          price={course.price}
          duration={course.duration}
          changeTarget={() =>
            onChangeTarget({ course: true, options: false, staff: false })
          }
          changeOption={() =>
            onChangeTarget({ course: false, options: true, staff: false })
          }
        />
      </BooksLabeledContainer>
    </div>
  );
};

export default injectIntl(InputBookingTargetPreview);
